<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'simbolosCrud'"
          crudName="Simbolos"
          newText="Novo Simbolo"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="true"
          :enableDownloadExcel="true"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="true"
          :enableActive="false"
          :enableReset="false"
          :enableSenhaPath="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "simbolosTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "photo", "nome", "actions"],
      tableData: ["id", "photo", "nome"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          photo: "simbolo",
          nome: "Nome",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          setor_id: function (h, row, index) {
            return row.setor ? row.setor.nome : "Indisponível";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "simbolos/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>